
<template  >
     <!-- place a root element -->
    <div>
        
        <div v-for="(item, index) in questions" :key="index"> 
         
            <div class="card card_evaluation"  style="min-height: 635px;" :id="'question_'+item.id" :key="index" v-if="item.id === question.id"   >
            
                <div class="card-header">
                    <h4>{{$t('planesYPrecios.paso-3.preselección.question')}} {{index + 1}}/{{questions.length}}</h4>
                    <div class="timer"><icon name="watch" />
                        <countdown :end-time="durationEvaluacion" :auto-start="autoStart" @finish="finalizarEvaluacion" ref="countdownEvaluacion" >
                            <template v-slot:process="anyYouWantedScopName" >
                                <label style="display:none"> {{time = `${anyYouWantedScopName.timeObj.h}:${anyYouWantedScopName.timeObj.m}:${anyYouWantedScopName.timeObj.s}` }}</label>
                                <template>{{ `${anyYouWantedScopName.timeObj.h}:${anyYouWantedScopName.timeObj.m}:${anyYouWantedScopName.timeObj.s}` }}</template>
                            </template>
                            <template v-slot:finish   >
                        
                            </template>	
                        </countdown>
                    </div>
                </div>
                <div class="card-body py-0">
                    <b-row>
                        <b-col>
                            <p  v-if="((item.type.value == tipoPreguntas.PREGUNTA_AUDIO && item.audio) || item.type.value != tipoPreguntas.PREGUNTA_AUDIO)">{{item.instruction }}</p>
                        <!-- 	<h4 v-if="item.type.value != tipoPreguntas.PREGUNTA_AUDIO && item.type.value != tipoPreguntas.PREGUNTA_DIGITAR" class="mb-4" >{{item.descripcionVisibleParaWeb.replaceAll("[br]","\n")}}</h4>  -->
                            <div class="audio_player" v-if="item.audio">
                                <icon name="music" />
                                    {{item.audioDuracion}}
                                <div class="progress">
                                    <div class="progress-bar" :style="{'width':progressAudio(item.audioObject)}"/>
                                </div>
                                <!-- <div class="option" @click.prevent="isPlaying ? pause(item.audio) : play(item.audio)"> -->
                                <div class="option enunciado" 
                                        @click.prevent="playAudio(item.audioObject, item.id,  true)" 
                                        :id="'audio_'+item.id" :data-id="item.id">
                                    <div class="contentBackground"></div>
                                    <!-- <i class="material-icons">{{questionAudioSelected == 0 && player != null && isPlaying ? 'pause' : 'play_arrow'}}</i> -->
                                </div>
                            </div>
                            <h4 v-if="item.type.value != tipoPreguntas.PREGUNTA_DIGITAR && item.type.value != tipoPreguntas.PREGUNTA_AUTOCOMPLETAR" class="mb-2 mb-md-4">
                                {{item.descripcionVisibleParaWeb.replaceAll("[br]","\n")}}
                            </h4>
                            <h4 v-if="item.type.value == tipoPreguntas.PREGUNTA_DIGITAR" class="center">
                                <template v-for="(node, n) in item.description.split(/(?:^|})|(?={)/)" >
                                    <input :id="'question_'+item.id + '_inputRpta'+n" :key="n"  v-if="n % 2"  v-model="questionsAnswersSelecteds.filter(o => o.questionId == item.id)[0].answerList[parseInt(node.replace('{', '').replace('}',''))]" @input="eventText($event, node, item.type.value)" @change="eventText($event, node,item.type.value)" autocomplete="off">
                                    <span :id="'inputRpta'+n" :key="'inputRpta'+n" v-else  v-html=" item.description.split(/(?:^|})|(?={)/)[n].replaceAll('[br]','\n')"></span>
                                </template>
                            </h4>
                            <h4 v-if="item.type.value == tipoPreguntas.PREGUNTA_AUTOCOMPLETAR" class="center" :class="item.type.value != tipoPreguntas.PREGUNTA_DIGITAR && item.tipoAlternativa==tipoAlternativa.ALTERNATIVA_IMAGEN ? 'mb-4' : ''">
                                <template v-for="(node, n) in item.description.split(/(?:^|})|(?={)/)" >
                                    <!-- <input disabled :id="'inputRpta'+n" :key="n"  v-if="n % 2"  v-model="questionsAnswersSelecteds.filter(o => o.questionId == item.id)[0].answerList[parseInt(node.replace('{', '').replace('}',''))]"> -->
                                    <span class="autoRpta" :id="'inputRpta'+n" :key="n"  v-if="n % 2">{{questionsAnswersSelecteds.filter(o => o.questionId == item.id)[0].answerList[parseInt(node.replace('{', '').replace('}',''))]}}</span>
                                    <span :id="'inputRpta'+n" :key="'inputRpta'+n" v-else  v-html=" item.description.split(/(?:^|})|(?={)/)[n].replaceAll('[br]','\n')"></span>
                                </template>
                            </h4>
                            
                            <!-- <label v-if="item.type.value == tipoPreguntas.PREGUNTA_AUDIO" class="qst">Select the connect option:</label> -->
                            <b-form-group class="alternatives" v-if="(item.tipoAlternativa!=tipoAlternativa.ALTERNATIVA_IMAGEN && item.type.value != tipoPreguntas.PREGUNTA_DIGITAR)">
                                <b-form-radio-group v-model="questionAnswerSelected" :autofocus="false" stacked>
                                    <b-form-radio v-for="(option, index) in questionsAnswers" :class="{audio:option.file}" :key="'r'+index" :value="option.id" @change="selectedQuestionAnswer(item.id, option.id, item.typeId)">
                                        <div class="audio_player" v-if="option.file">
                                            {{option.audioDuracion}}
                                            <!-- <div class="option" @click.prevent="isPlaying ? pause(option.audio) : play(option.audio)" > -->
                                            <div class="option" @click.prevent="playAudio(option.audioOption, (item.id + '_' + option.id))" :id="'audio_'+item.id + '_' + option.id" :data-id="item.id + '_' + option.id">
                                                <!-- <i class="material-icons">{{questionAudioSelected == index+1 && player != null && isPlaying ? 'pause' : 'play_arrow'}}</i> -->
                                                <div class="contentBackground"></div>
                                            </div>
                                        </div>
                                        {{option.answer}} 
                                    </b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                            <ul v-else-if="item.type.value != tipoPreguntas.PREGUNTA_DIGITAR" class="select-images">
                                <li :class="option.id === questionAnswerSelected ? 'box active' : 'box'" class="box" v-for="(option, index) in questionsAnswers" :key="'questionAnswer'+index" :value="option.id" @click="selectedQuestionAnswer(item.id, option.id, item.typeId)">
                                    <b-img :src="option.file"></b-img>
                                </li>
                            </ul>
                        </b-col>
                        <b-col md="5" class="text-center text-md-right" v-if="item.image">
                            <b-img class="img-qst" :src="item.image"/>
                        </b-col>
                    </b-row>
                </div>
                <div class="card-footer">
                    <b-row class="flex-column-reverse flex-md-row">
                        <b-col md="6">
                            <b-button class="pl-0 mr-4" :disabled="index ==0" variant="link" @click="questions.findIndex(element => element.id === item.id) == 0 ? step-- : prev()">
                                <i class="material-icons mr-1">chevron_left</i>{{$t('planesYPrecios.paso-3.evaluacion.buttons.regresar')}}
                            </b-button>
                            <b-button v-if="!isLoading" variant="primary"  @click="next(questions.findIndex(element => element.id === item.id))"   :class="{ loading: isLoadingEval }">
                                {{questions.findIndex(element => element.id === item.id) == questionsAnswersSelecteds.length -1 ? $t('planesYPrecios.paso-3.evaluacion.buttons.terminar') : $t('planesYPrecios.paso-3.evaluacion.buttons.siguiente')}}
                                <i v-show="questions.findIndex(element => element.id === item.id) != questionsAnswersSelecteds.length -1"
                                     class="material-icons ml-1">navigate_next</i>
                            </b-button>
                            <b-button v-else  variant="primary"  :disabled="true">
                                {{$t('reusables.loading')}}
                            </b-button>
                        </b-col>
                        <b-col md="6">
                            <div class="question_number">
                                <button v-for="(item, index) in questions"   
                                    :key="index" :id="'index_fila1'+index" 
                                    v-bind:class="[questionsAnswersSelecteds.filter(o => o.questionId == questions[index].id)[0].response ? 'btn active' : 'btn', questions[index].id === question.id ? 'btn-index' : '']" 
                                    @click="selectedQuestion(questions[index].id,questions[index].typeId);" >
                                    {{index + 1}}
                                </button>
                            </div>
                            <!-- <div class="question_number">
                                <button v-for="(item, index) in Math.ceil(questions.length/2)"
                                    v-show="(index + Math.ceil(questions.length/2)) < questions.length" 
                                    :key="index" :id="'index_fila2_'+ (index + Math.ceil(questions.length/2))" 
                                    v-bind:class="questions[index + Math.ceil(questions.length/2)] == null  ? null :[questionsAnswersSelecteds.filter(o => o.questionId == questions[index + Math.ceil(questions.length/2)].id)[0].response ? 'btn active' : 'btn', questions[index+ Math.ceil(questions.length/2)].id === question.id ? 'btn-index' : '']" 
                                    @click="selectedQuestion(questions[index + Math.ceil(questions.length/2)].id, questions[index + Math.ceil(questions.length/2)].typeId);" >
                                    {{questions[index + Math.ceil(questions.length/2)] != null  ? index + Math.ceil(questions.length/2) + 1 : ""}}
                                </button>
                            </div> -->
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import  {TIPO_PREGUNTAS,TIPO_PREGUNTAS_ALTERNATIVAS}  from '@/assets/js/appConstants'; 

export default {
	components:{
		 
	},
    data(){
        return{
            lang:localStorage.getItem('lang') || 'es',
            API_URL: process.env.VUE_APP_API_URL,
            durationEvaluacion: new Date().getTime() + 0,
            tipoPreguntas:TIPO_PREGUNTAS,
            tipoAlternativa:TIPO_PREGUNTAS_ALTERNATIVAS ,
            nextText: '',
            isPlaying: false,
            player: null,
            finishedAudio:false,
            flagAudioEnunciado:true,
            duration: 0,
            time: '00:00:00',
            currentTime: 0,
            lastTime: 0,
            timeBegan: null,
            timeStopped: null,
            stoppedDuration: 0,
            started: null,
            running: false,
            autoStart:true,
            question:{  id: 0,
                        answer: '',
                        typeId: 0
                    },
            questionsAnswers: [],
            questionsAnswersSelecteds:[],
            questionAnswerSelected: null,
            questionAudioSelected: null, 
            evaluationData : null,
            isLoading: false,
            isLoadingEval: false
        }
    },
    mounted(){
		this.start();
	},
    methods:{
        start() {
            
            var minutosEvaluacion = this.evaluation.duration;
            var segundosEvaluacion =(minutosEvaluacion*60)*1000;
            this.durationEvaluacion = new Date().getTime() + segundosEvaluacion;
            this.autoStart=true;
        },
        getQuestionsAnswers: function(evaluationQuestionId) {
			 
            
            var selected = this.questionsAnswersSelecteds.find(element => element.questionId == evaluationQuestionId);
            if(selected != null){
                this.questionsAnswers = selected.listEvaluationsQuestionsAnswers;
            } 
        },
        selectedQuestion: function(questionId,typeId) {
            this.question = {
                id: questionId,
                typeId:typeId
            };
            this.resetPlayer()
            this.getQuestionsAnswers(questionId);
            this.questionAnswerSelected = this.questionsAnswersSelecteds.filter(element => element.questionId == questionId)[0].questionAnswerId;
        },
        selectedQuestionAnswer: function(questionId, questionAnswerId,typeId) {
            var exists = false;
             
            var element = this.questionsAnswersSelecteds.find(z => z.questionId == questionId);
            if(element != null){
                element.questionAnswerId = questionAnswerId;
                element.answer = '';
                element.response = questionAnswerId > 0 ? true : false;
                exists = true;
                element.typeId = typeId;

            }

            if (!exists) {
                this.questionsAnswersSelecteds.push(
                    {
                        questionId: questionId,
                        questionAnswerId: questionAnswerId,
                        answer: '',
                        response: questionAnswerId > 0 ? true : false,
                        typeId : typeId
                    }
                );
            }

            this.questionAnswerSelected = this.questionsAnswersSelecteds.filter(element => element.questionId == questionId)[0].questionAnswerId;
            this.setQuestionAnswer(questionId, questionAnswerId);
        },
        digitQuestionAnswer: function(questionId, answer, typeId) {
            var exists = false;
            this.questionsAnswersSelecteds.forEach(element => {
                if (element.questionId == questionId) {
                    element.questionAnswerId = 0;
                    element.answer =  answer;
                    element.response = answer.length > 0 ? true : false;
                    exists = true;
                    element.typeId = typeId;
                }
            });

            if (!exists) {
                this.questionsAnswersSelecteds.push(
                    {
                        questionId: questionId,
                        questionAnswerId: 0,
                        answer: answer,
                        response: answer.length > 0 ? true : false,
                        typeId : typeId
                    }
                );
            }

            // this.openDataBase();
        },
        setQuestionAnswer: function(questionId, questionAnswerId) {

            var objQuestion = this.questions.find(z => z.id == questionId  && z.type.value == this.tipoPreguntas.PREGUNTA_AUTOCOMPLETAR);
            if(objQuestion != null){
        

                var respuestaSeleccionada = this.questionsAnswers.filter(questionAnswer => questionAnswer.id == questionAnswerId)[0].answer;
                let respuestaSeleccionadaOtra = this.questionsAnswersSelecteds.find(questionAnswer => questionAnswer.questionId == questionId);
                    
                let rptaSeleccionada = respuestaSeleccionada.split("/");

                if(respuestaSeleccionadaOtra != null){
                    for(var i = 0; i < respuestaSeleccionadaOtra.answerList.length; i++){
                        respuestaSeleccionadaOtra.answerList[i] = rptaSeleccionada[i];
                        this.$forceUpdate();
                    }

                }
                

            }
 
            
        },
        next: function(i) {
            this.resetPlayer()
            if((this.questions.length -1) == i) {
                this.isLoading = true;
                this.$refs.countdownEvaluacion[0].stopCountdown();
                this.durationEvaluacion = new Date().getTime() + 0;
                this.autoStart = false; 
                this.send();
            //this.step = 2;
            } else {
                this.selectedQuestion(this.questions[i + 1].id,this.questions[i + 1].typeId);
            }
        },
        prev: function() {
            this.selectedQuestion(this.questions[this.questions.findIndex(element => element.id === this.question.id) - 1].id,this.questions[this.questions.findIndex(element => element.id === this.question.id) - 1].typeId);
        },
        pauseThisAudio(audioSrc, index, duration) {
            let id = document.getElementById(`audio_${index}`)
            id.classList.remove('active')
            audioSrc.currentTime = 0
            audioSrc.pause()
        },
        playAudio(audioSrc, index, title = false) {
            // this.resetPlayer()
        
            //debugger;
            let total = this.questionsAnswers.length
            let id = document.getElementById(`audio_${index}`)

            // let count = this.questionsAnswers.filter(x => x.id == index)
            // if(title && this.player != null && count.length == 0) {
            // 	let _el = document.getElementById(`audio_${this.player.index}`)
            // 	if(_el)_el.classList.remove('active')
            // }
            
            /**/
            var self = this;
            var ad;
            var div = document.querySelectorAll('.audio_player .option');
            div.forEach(function(elem) {
            
                var idAd = elem.dataset.id;
                if(index != idAd){
                    elem.classList.remove("active");
                }

                //DETENER EL AUDIO DEL ENUNCIADO
                if(index != idAd){
                    var enunciado = self.questions.find(x => x.id == idAd);
                    if(enunciado != null){
                        ad = enunciado.audioObject;
                        if(ad != null){
                            //ad.currentTime = 0
                            
                            ad.pause();
                            
                        }
                    }
                }

                //DETENER TODOS LOS AUDIOS DE LAS ALTERNATIVAS
            
                var alternative = self.questionsAnswers.find(x => x.id == idAd.split("_")[1]);
                if(alternative != null){
                    ad = alternative.audioOption;
                    if(ad != null){
                        ad.currentTime = 0
                        
                        ad.pause();
                    }
                }
                
            });
            
            
            /*
            for(let i = 0; i < total; i++) {
                var ad = this.questionsAnswers[i].audioOption
                if(this.questionsAnswers[i].id != index) {
                    let _id = this.questionsAnswers[i].id
                    let _el = document.getElementById(`audio_${_id}`)
                    if(_el) _el.classList.remove('active')
                    
                    ad.currentTime = 0
                }
                ad.pause();
            }
            
            for(let i = 0; i < total; i++) {
                var ad = this.questionsAnswers[i].audioOption
                if(ad != null){
                    if(this.questionsAnswers[i].id != index) {
                        let _id = this.questionsAnswers[i].id;
                        let _evaluationQuestionId = this.questionsAnswers[i].evaluationQuestionId;
                        let _el = document.getElementById(`audio_${_evaluationQuestionId}_${_id}`)
                        if(_el) _el.classList.remove('active')
                        
                        ad.currentTime = 0
                    }
                    ad.pause();
                }
            }
            */

            if(!id.classList.contains('active')) {
                id.classList.add('active')
                this.isPlaying = true; 
                //audioSrc.currentTime = 0
                audioSrc.play()
            }
            else {
                id.classList.remove('active')
                this.isPlaying = false; 
                audioSrc.pause()
            }
            
            audioSrc.onended = function(){
                id.classList.remove('active')
                audioSrc.currentTime = 0
                audioSrc.pause()
            }

            this.player = { audioSrc, index };
        
        },
        resetPlayer() {
            if(this.player != null ) {
                const div = document.querySelectorAll('.option');
                div.forEach(a => a.classList.remove("active"))
                this.player.audioSrc.pause();
                this.player.audioSrc.currentTime = 0;
                this.isPlaying = false;
                
            }
        },
        eventText: function (event, expFind, questionType) {
            var rptaDigitada = event.target.value;
            if(questionType == this.tipoPreguntas.PREGUNTA_DIGITAR){
                var rpta = this.questionsAnswersSelecteds.find(z => z.questionId == this.question.id);
                if(rpta != null){
                    var idx = parseInt( expFind.replace("{", "").replace("}", ""));
                    rpta.answerList[idx] = event.target.value;

                    rptaDigitada = rpta.answerList.join("/");

                }
                    
            }
            this.digitQuestionAnswer(this.question.id, rptaDigitada,this.question.typeId);
        }
        ,
        audioDuration(audio, flagAudioEnunciado) {
            this.flagAudioEnunciado = flagAudioEnunciado;
        
            let durmin = Math.floor(audio.duration / 60);
            let dursec = Math.floor(audio.duration - durmin * 60);
            let curmin = Math.floor(audio.currentTime / 60);
            let cursec = Math.floor(audio.currentTime - curmin * 60);
            if (durmin < 10) {
                durmin = "0" + durmin;
            }
            if (dursec < 10) {
                dursec = "0" + dursec;
            }
            if (curmin < 10) {
                curmin = "0" + curmin;
            }
            if (cursec < 10) {
                cursec = "0" + cursec;
            }
            if(curmin == durmin && cursec == dursec) {
                this.isPlaying = false;
                this.finishedAudio = true;
            
                return "00:00" + " / " + durmin + ":" + dursec
            } else {
                this.finishedAudio = false;
            
                return curmin + ":" + cursec + " / " + durmin + ":" + dursec
            }
        },
        progressAudio(audio) {
            if(this.player != null && !isNaN(this.player.index)){
                let width = (100 / audio.duration) * audio.currentTime;
            
                if(this.finishedAudio) {
                    return 100 + "%";
                } else {
                    return (width) + "%";
                }
            }
        },
        send() {
            this.isLoadingEval = true;
            this.questionsAnswersSelecteds.forEach(element => {
                if (element.answerList != null) {
                    //quitando espacios en blanco
                    element.answer = element.answerList.map(s => s.trim()).join('/');

                }
            });


            this.started = null;
            this.data = this.questionsAnswersSelecteds;
            let objectEvaluation = {
                listAnswersSelecteds :this.questionsAnswersSelecteds,
                evaluation:this.evaluation,
                timeDuration: this.time,
                duration:this.evaluation.duration,
            }
    
            this.$emit('listenChild', objectEvaluation);
        },
        finalizarEvaluacion:function(){
            //console.log("finalizarEvaluacion");
            if (this.$refs.countdownEvaluacion!=undefined) {
                this.$refs.countdownEvaluacion[0].stopCountdown();
                this.durationEvaluacion = new Date().getTime() + 0;
                this.autoStart = false; 
                this.send();
                //this.step = 2; 
            }
        },
        validateProps() {
            if (this.questions != null && this.questions.length != 0) {

                var self = this;
                this.questions.forEach(element => {
                
                    element.descripcionVisibleParaWeb = element.description;

                    if(element.audio){
                        element.audioObject = new Audio(element.audio);
                        element.audioObject.ontimeupdate = function() {
                            element.audioDuracion = self.audioDuration(this, true);
                            self.$forceUpdate();
                        };
                        element.audioObject.onloadedmetadata = function() {
                            element.audioDuracion = self.audioDuration(this, true);
                            self.$forceUpdate();
                        };
                    }
                    
                    //alternativas del tipo audio
                    var self2 = self;
                    element.listEvaluationsQuestionsAnswers.forEach(alternative => {
                        if(alternative.file){
                            alternative.audioOption = new Audio(alternative.file)
                            alternative.audioOption.ontimeupdate = function() {
                                alternative.audioDuracion = self2.audioDuration(this, false);
                                self2.$forceUpdate();
                            };
                            alternative.audioOption.onloadedmetadata = function() {
                                alternative.audioDuracion = self2.audioDuration(this,false);
                                self.$forceUpdate();
                            };
                        }

                    });

                    this.questionsAnswersSelecteds.push(
                        {
                            questionId: element.id,
                            questionAnswerId: 0,
                            answer:'',
                            answerList: element.type.value === this.tipoPreguntas.PREGUNTA_DIGITAR || element.type.value === this.tipoPreguntas.PREGUNTA_AUTOCOMPLETAR?  new Array(element.description.match(/{/g).length) : null,
                            response: false,
                            typeId:element.typeId,
                            listEvaluationsQuestionsAnswers:element.listEvaluationsQuestionsAnswers
                        }
                    );
                });
            

                this.question =   {
                    id: this.questions[0].id,
                    typeId:this.questions[0].typeId
                };

                this.getQuestionsAnswers(this.question.id);
            }
        }
    },
	props: {
        evaluation:{
            type: Object
        },
		questions: {
			type: Array
		} 
        
	},
    watch: {
        $props: {
            immediate: true,
            handler() {
                this.validateProps();
            }
        }
    }
    
}

</script>
<style>
#question_52 .card-body h4 input{
    width:100%; 
}
 

</style>